// Indian banks offered in the signup Bank Name dropdown.
// Set isShow to false to hide a bank from the dropdown.
export const BANKS = [
    // Public sector banks
    { name: "State Bank of India", isShow: true },
    { name: "Punjab National Bank", isShow: true },
    { name: "Bank of Baroda", isShow: true },
    { name: "Canara Bank", isShow: true },
    { name: "Union Bank of India", isShow: true },
    { name: "Bank of India", isShow: true },
    { name: "Indian Bank", isShow: true },
    { name: "Central Bank of India", isShow: true },
    { name: "Indian Overseas Bank", isShow: true },
    { name: "UCO Bank", isShow: true },
    { name: "Bank of Maharashtra", isShow: true },
    { name: "Punjab & Sind Bank", isShow: true },

    // Private sector banks
    { name: "HDFC Bank", isShow: true },
    { name: "ICICI Bank", isShow: true },
    { name: "Axis Bank", isShow: true },
    { name: "Kotak Mahindra Bank", isShow: true },
    { name: "IndusInd Bank", isShow: true },
    { name: "Yes Bank", isShow: true },
    { name: "IDBI Bank", isShow: true },
    { name: "Federal Bank", isShow: true },
    { name: "South Indian Bank", isShow: true },
    { name: "Bandhan Bank", isShow: true },
    { name: "IDFC FIRST Bank", isShow: true },
    { name: "RBL Bank", isShow: true },
    { name: "Karnataka Bank", isShow: true },
    { name: "Karur Vysya Bank", isShow: true },
    { name: "City Union Bank", isShow: true },
    { name: "CSB Bank", isShow: true },
    { name: "DCB Bank", isShow: true },
    { name: "Dhanlaxmi Bank", isShow: true },
    { name: "Jammu & Kashmir Bank", isShow: true },
    { name: "Nainital Bank", isShow: true },
    { name: "Tamilnad Mercantile Bank", isShow: true },

    // Small finance banks
    { name: "AU Small Finance Bank", isShow: true },
    { name: "Equitas Small Finance Bank", isShow: true },
    { name: "Ujjivan Small Finance Bank", isShow: true },
    { name: "Jana Small Finance Bank", isShow: true },
    { name: "Suryoday Small Finance Bank", isShow: true },
    { name: "Utkarsh Small Finance Bank", isShow: true },
    { name: "ESAF Small Finance Bank", isShow: true },
    { name: "Capital Small Finance Bank", isShow: true },
    { name: "Fincare Small Finance Bank", isShow: true },
    { name: "North East Small Finance Bank", isShow: true },
    { name: "Shivalik Small Finance Bank", isShow: true },
    { name: "Unity Small Finance Bank", isShow: true },

    // Payments banks
    { name: "Paytm Payments Bank", isShow: true },
    { name: "Airtel Payments Bank", isShow: true },
    { name: "India Post Payments Bank", isShow: true },
    { name: "Fino Payments Bank", isShow: true },
    { name: "Jio Payments Bank", isShow: true },
    { name: "NSDL Payments Bank", isShow: true },

    // Foreign banks
    { name: "Citibank", isShow: true },
    { name: "HSBC Bank", isShow: true },
    { name: "Standard Chartered Bank", isShow: true },
    { name: "Deutsche Bank", isShow: true },
    { name: "DBS Bank India", isShow: true },
    { name: "Barclays Bank", isShow: true },

    // Regional rural & cooperative banks
    { name: "Saraswat Co-operative Bank", isShow: true },
    { name: "Cosmos Co-operative Bank", isShow: true },
    { name: "Bharat Co-operative Bank", isShow: true },
    { name: "TJSB Sahakari Bank", isShow: true },
    { name: "Kerala Gramin Bank", isShow: true },
    { name: "Andhra Pradesh Grameena Vikas Bank", isShow: true },
    { name: "Karnataka Gramin Bank", isShow: true },
    { name: "Uttar Bihar Gramin Bank", isShow: true },
    { name: "Baroda UP Bank", isShow: true },
    { name: "Punjab Gramin Bank", isShow: true }
];
